import { Spin, Modal, Image, Space, Button, Table, Tooltip, Popconfirm } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Utils from '../../misc/Utils';
// import Enums from '../../misc/Enums';

export default function ZoomPickerV2(props) {
   const [open, setOpen] = useState(props.open || false);
   const [loading, setLoading] = useState(true);
   const [zoomPickerList, setZoomPickerList] = useState([]);
   var subdomain = localStorage.getItem("lms-subdomain");

   useEffect(() => {
      getZoomPickerList();
   }, []);

   const handleEnterClass = (joinUrl) => {
      if (joinUrl) {
         window.open(joinUrl, '_blank');
      } else {
         Utils.showNotification('error', 'Error', 'Join URL is not available for this room.');
      }
   }

   const zoomPickerColumns = [
      {
         title: 'Room Name',
         key: 'roomName',
         render: payload => (
            //payload.roomName.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
            payload.roomName
         ),
         width: '80%'
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => (
            <Tooltip placement="left" title='Enter Room'>
               <Popconfirm
                  title="Are you sure you want to enter the room?"
                  onConfirm={() => handleEnterClass(payload.JoinUrl)}
                  okText="Yes"
                  cancelText="No"
               >
                  <img alt='zoom' style={{ cursor: 'pointer', borderRadius: '7px' }} height={28} src={"../images/zoom_logo.png"}></img>
               </Popconfirm>
            </Tooltip>
         ),
         width: '20%'
      }
   ]

   const getZoomPickerList = () => {
      setLoading(true);

      let url = `${process.env.REACT_APP_API_ZOOM}/v2/zoompickerlist?sc=${subdomain}`;
      axios.get(url, { headers: {} }).then((response) => {
         if (response.data) {
            let data = response.data;
            setZoomPickerList(data);
         }

         setLoading(false);
      }, (error) => {
         setLoading(false);
         console.log(error.message);
      });
   }

   return (
      <>
         <div style={{ textAlign: 'center' }}>
            <Table
               rowKey={'uid'}
               loading={loading}
               size='small'
               columns={zoomPickerColumns}
               dataSource={zoomPickerList}
               pagination={false}
               scroll={{
                  y: 'calc(100vh - 260px)',
                  x: '300px',
               }}
            />
         </div>
      </>
   );
}